import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { recordActions, Auth } from '../../config/configuration/react';
import { useOfferCommon } from '../useAutobizTrade/useOfferCommon';

export const useOffersTable = ({ saleStatus, recordId, saleId, offers }) => {
  const roleId = Auth.roleId();
  const [purchaseOrderValue, setPurchaseOrderValue] = useState(null);
  const hideMerchantInfoForUser = Auth.isAllowedToSeeMerchant();
  const [counterOfferStatus, setCounterOfferStatus] = useState(null);
  const [body, setBody] = useState('');
  const [winner, setWinner] = useState(null);

  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [merchantName, setMerchantName] = useState('');
  const [isOpenCounterOffer, setIsOpenCounterOffer] = useState(false);
  const [previousWinnerState, setPreviousWinnerState] = useState(null);
  const [bodyCounterOffer, setBodyCounterOffer] = useState('');
  const [counterOfferAmount, setCounterOfferAmount] = useState(null);
  const [offerAmount, setOfferAmount] = useState(null);
  const [offerId, setOfferId] = useState(null);
  const [userIdCounterOffer, setUserIdCounterOffer] = useState(null);
  const [inferiorCounterOffer, setInferiorCounterOffer] = useState(null);
  const [isOpenEncheres, setIsOpenEncheres] = useState(false);
  const [bodyEncheres, setBodyEncheres] = useState('');
  const [partnerOfferId, setPartnerOfferId] = useState(null);
  const [pickUpModal, setPickUpModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pickupSitesData, setPickUpSitesData] = useState(null);
  const [selectedWithdrawalSite, setSelectedWithdrawalSite] = useState(null);
  const [selectedBillingSite, setSelectedBillingSite] = useState(null);
  const [currentPartnerOfferId, setCurrentPartnerOfferId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [postedPickupData, setPostedPickupData] = useState(null);
  const [partnerOfferResponse, setPartnerOfferResponse] = useState(null);

  const getAmount = (a) => a.value;
  const getDate = (a) => a.lastOfferCreatedAt;

  const { sortTypes, onSortChange, sortFunction, isFinished, currentSortAmount, currentSortCreatedAt } = useOfferCommon(
    { saleStatus, getAmount, getDate },
  );

  const displayPurchaseOrder = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.displayPurchaseOrder,
  );
  const hideMerchantInfo = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.hideMerchantInfo,
  );
  const displayOnlyWinnersInfo = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.displayOnlyWinnersInfo,
  );
  const enableAlcopaPickUpPlace = useSelector(
    (state) => state.reduxRecords.data[recordId]?.sourceInfos?.sourceGroupData?.enableAlcopaPickUpPlace,
  );

  useEffect(() => {
    offers.forEach((i) => {
      if (i.winner || i.counter_offer?.is_winner) {
        setWinner(i);
      }
    });
    if (
      offers?.find((o) => o.counter_offer?.is_accepted === true) ||
      offers?.find((o) => o.counter_offer?.amount > 0 && o.counter_offer?.is_accepted === null)
    ) {
      setCounterOfferStatus(true);
    } else {
      setCounterOfferStatus(false);
    }
  }, [offers]);

  const toggle = () => {
    // setUserId('');
    setBody('');
    setIsOpen(!isOpen);
  };
  const [isOpenPurchaseOrder, setIsOpenPurchaseOrder] = useState(false);

  const validateBtn = 'submit';
  const cancelBtn = 'cancel';

  const toggleCounterOffer = () => {
    setUserIdCounterOffer('');
    setBodyCounterOffer('');
    setIsOpenCounterOffer(!isOpenCounterOffer);
    setCounterOfferAmount(null);
    setInferiorCounterOffer(false);
  };

  const toggleEncheres = () => {
    setBodyEncheres('');
    setIsOpenEncheres(!isOpenEncheres);
  };

  const handleCancel = () => {
    toggle();
    setWinner(previousWinnerState);
  };

  const handleCancelCounterOffer = () => {
    toggleCounterOffer();
  };

  const onChangeWinner = (e, i) => {
    if (e.target.checked) {
      setIsOpen(true);
      // setUserId(i.userId);
      setMerchantName(i.partnerName);
      setWinner(i);
      setPreviousWinnerState(winner);
    } else {
      setIsOpen(true);
      // setUserId(i.userId);
      setMerchantName(i.partnerName);
      setWinner(null);
      setPreviousWinnerState(winner);
    }
  };

  const onChangeEncheres = (e, i) => {
    setIsOpenEncheres(true);
    setPartnerOfferId(i?.partner_offer?.id);
  };

  const onChangeCounterOfferDetails = (offer) => {
    setOfferId(offer.id);
    setOfferAmount(offer.value);
    setUserIdCounterOffer(offer.userId);
    setIsOpenCounterOffer(true);
  };

  const togglePurchaseOrder = () => {
    setIsOpenPurchaseOrder(!isOpenPurchaseOrder);
  };

  const handlePurchaseOffer = async () => {
    togglePurchaseOrder();
    const res = await dispatch(recordActions.generatePurchaseOrder(saleId));
    setPurchaseOrderValue(res?.name);
  };

  const handlePutWinner = async () => {
    let data = {};
    if (winner) {
      data = { is_winner: true };
      setOfferId(winner.id);
    } else {
      try {
        if (
          offers.filter((o) => o.id === Object.keys(previousWinnerState)[0])[0].counter_offer &&
          offers.filter((o) => o.id === Object.keys(previousWinnerState)[0])[0].counter_offer?.is_accepted
        ) {
          const {
            counterOffer: { uuid },
            userId: counterOfferUserId,
          } = offers.filter((o) => o.id === Object.keys(previousWinnerState)[0])[0];
          await dispatch(recordActions.putCounterOffer(uuid, counterOfferUserId, false));
        }
      } catch (error) {
        console.log('error ', error);
      }
      data = { is_winner: false };
      setOfferId(previousWinnerState.id);
    }
    toggle();
    const res = await dispatch(recordActions.putOffer(winner ? winner.id : previousWinnerState.id, data));
    if (res?.id) {
      await dispatch(recordActions.fetchCoverageOffers(recordId));
    }
  };

  const handlePutEncheres = async (is_accepted) => {
    try {
      await dispatch(recordActions.putPartnerRequest(partnerOfferId, is_accepted));
      await setPartnerOfferResponse({
        is_accepted,
      });
      toggleEncheres();
      await dispatch(recordActions.fetchCoverageOffers(recordId));
    } catch (e) {
      console.log('error ', e);
      toggleEncheres();
    }
  };

  const handleSendCounterOffer = async () => {
    try {
      if (counterOfferAmount !== null && counterOfferAmount > offerAmount) {
        await dispatch(recordActions.postCounterOffer(counterOfferAmount, offerId, userIdCounterOffer, saleId));
        toggleCounterOffer();
      } else {
        setInferiorCounterOffer(true);
      }
    } catch (error) {
      toggleCounterOffer();
      console.log('error while creating a counter offer ', error);
    }
  };

  const changeCounterOfferAmount = (e) => {
    setCounterOfferAmount(e.target.value);
  };

  const bluring = (purchaseOrderData, merchant) => {
    if (roleId === 1) {
      return true;
    }
    if (hideMerchantInfoForUser) {
      return true;
    }
    if (!purchaseOrderData) {
      if (hideMerchantInfo) {
        return true;
      }
      return false;
    }
    if (displayOnlyWinnersInfo && merchant.winner) {
      return false;
    }
    if (displayOnlyWinnersInfo && !merchant.winner) {
      return true;
    }
    return false;
  };

  const handlePickupManagement = async (idPartnerOffer) => {
    setIsLoading(true);
    try {
      const pickupData = await dispatch(recordActions.fetchPickupSites());
      setPickUpSitesData(pickupData);
      setCurrentPartnerOfferId(idPartnerOffer);
      setPickUpModal(true);
    } catch (e) {
      console.error(e.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePickupData = async () => {
    const withdrawalSiteId = selectedWithdrawalSite?.id;
    const withdrawalSiteName = selectedWithdrawalSite?.name;
    const billingSite = selectedBillingSite;
    const auctionGroupId = pickupSitesData?.defaultAuctionGroupId?.get_default_auction_group_id;
    const idPartnerOffer = currentPartnerOfferId;
    if (!withdrawalSiteId || !billingSite || !idPartnerOffer) {
      setErrorMessage(true);
      return;
    }
    setPostedPickupData({
      withdrawalSiteId,
      withdrawalSiteName,
      billingSite,
      auctionGroupId,
      idPartnerOffer,
    });
    setIsSubmitting(true);
    try {
      await dispatch(
        recordActions.postPickupSites(
          withdrawalSiteId,
          withdrawalSiteName,
          billingSite,
          auctionGroupId,
          idPartnerOffer,
        ),
      );
      await setPickUpModal(false);
      await dispatch(recordActions.fetchCoverageOffers(recordId));
    } catch (e) {
      console.error(e.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (selectedWithdrawalSite && selectedBillingSite && currentPartnerOfferId) {
      setErrorMessage(false);
    }
  }, [selectedWithdrawalSite, selectedBillingSite, currentPartnerOfferId]);

  // const handlePurchaseOrderCancel = () => {
  //   togglePurchaseOrder();
  // };

  // const sortTypes = {
  //   amount: {
  //     down: {
  //       icon: faSortDown,
  //       fn: (a, b) => a.value - b.value,
  //     },
  //     up: {
  //       icon: faSortUp,
  //       fn: (a, b) => b.value - a.value,
  //     },
  //     default: {
  //       icon: faSort,
  //       fn: (a) => a,
  //     },
  //   },
  //   lastOfferCreatedAt: {
  //     down: {
  //       icon: faSortDown,
  //       fn: (a, b) => moment(a.lastOfferCreatedAt) - moment(b.lastOfferCreatedAt),
  //     },
  //     up: {
  //       icon: faSortUp,
  //       fn: (a, b) => moment(b.lastOfferCreatedAt) - moment(a.lastOfferCreatedAt),
  //     },
  //     default: {
  //       icon: faSort,
  //       fn: (a) => a,
  //     },
  //   },
  // };

  // const onSortChange = (sortColumnParam) => {
  //   let nextSort;
  //   if (sortColumnParam === 'amount') {
  //     if (currentSortAmount === 'down') nextSort = 'up';
  //     else if (currentSortAmount === 'up') nextSort = 'default';
  //     else if (currentSortAmount === 'default') nextSort = 'down';
  //     setCurrentSortAmount(nextSort);
  //     setCurrentSortCreatedAt('default');
  //   } else if (sortColumnParam === 'lastOfferCreatedAt') {
  //     if (currentSortCreatedAt === 'down') nextSort = 'up';
  //     else if (currentSortCreatedAt === 'up') nextSort = 'default';
  //     else if (currentSortCreatedAt === 'default') nextSort = 'down';
  //     setCurrentSortCreatedAt(nextSort);
  //     setCurrentSortAmount('default');
  //   }
  //   setCurrentSortedColumn(sortColumnParam);
  // };

  // const sortTarget = currentSortedColumn === 'amount' ? currentSortAmount : currentSortCreatedAt;
  // const sortFunction = sortTypes[currentSortedColumn][sortTarget].fn;
  // const isFinished = [
  //   'CLOSED',
  //   'FINISHED',
  //   'ARCHIVED',
  //   'winner_to_designate',
  //   'closed_order_confirmed',
  //   'closed_no_purchase',
  // ].includes(saleStatus);
  return {
    sortFunction,
    isFinished,
    sortTypes,
    currentSortCreatedAt,
    currentSortAmount,
    validateBtn,
    cancelBtn,
    body,
    bodyCounterOffer,
    setBody,
    setBodyCounterOffer,
    changeCounterOfferAmount,
    handleSendCounterOffer,
    handlePutWinner,
    onSortChange,
    onChangeCounterOfferDetails,
    onChangeWinner,
    handleCancelCounterOffer,
    handleCancel,
    toggle,
    toggleCounterOffer,
    merchantName,
    isOpen,
    isOpenCounterOffer,
    counterOfferStatus,
    counterOfferAmount,
    inferiorCounterOffer,
    offerAmount,
    winner,
    isOpenEncheres,
    toggleEncheres,
    bodyEncheres,
    setBodyEncheres,
    handlePutEncheres,
    onChangeEncheres,
    handlePurchaseOffer,
    togglePurchaseOrder,
    isOpenPurchaseOrder,
    displayPurchaseOrder,
    purchaseOrderValue,
    bluring,
    enableAlcopaPickUpPlace,
    pickUpModal,
    setPickUpModal,
    isLoading,
    setIsLoading,
    pickupSitesData,
    selectedWithdrawalSite,
    setSelectedWithdrawalSite,
    selectedBillingSite,
    setSelectedBillingSite,
    isSubmitting,
    handlePickupManagement,
    handlePickupData,
    errorMessage,
    postedPickupData,
    partnerOfferResponse,
    roleId,
  };
};
